import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { SettingsProvider } from '@services/settings/settings';
import { QuoteUpdateService } from '@services/quote/quote-update.service';
import { TimeServiceProvider } from '@services/helpers/time-service/time.service';
import { ShootProofDataProvider } from '@services/integrations/shootProof/shootProof.data.service';
import { InvoicesDataProvider } from '../../../../../../../shared/services/invoice/invoices-data-service/invoices.data.service';

@Component({
	selector: 'create-new-shootproof-gallery-modal',
	template: require('./create-new-shootProof-gallery.modal.html'),
	styles: [require('./create-new-shootProof-gallery.modal.scss')]
})
export class CreateNewShootProofGalleryModal implements OnInit {
	@Input('brandsGalleries') brandsGalleries: Array<any>;
	@Input('jobId') jobId: number;

	@Output('updateGalleries')
	updateGalleries: EventEmitter<any> = new EventEmitter<any>();

	name: string;
	_jobName: string;
	@Input('jobName')
	set jobName(value) {
		this.name = value;
		this._jobName = value;
	}

	get jobName() {
		return this._jobName;
	}

	eventDate;
	_mainShootDate;
	@Input('mainShootDate')
	set mainShootDate(value) {
		this.eventDate =
			value === null ? null : this.quoteUpdateService.setQuoteIssueDate(value);
		this._mainShootDate =
			value === null ? null : this.quoteUpdateService.setQuoteIssueDate(value);
	}
	get mainShootDate() {
		return this.eventDate;
	}
	datePlaceHolder = '';

	selectedBrandId = -1;
	selectedPresetId = -1;
	submitDisable = false;
	spBrandThemeId = null;

	readonly DEFAULT_GALLERY_PRESET = [{ id: -1, name: 'Choose Preset' }];
	readonly LOADING_GALLERY_PRESET = [{ id: -1, name: 'Loading...' }];

	disabledGalleryPresetSelect = false;

	galleryPresets = this.DEFAULT_GALLERY_PRESET;

	constructor(
		private shootProofDataService: ShootProofDataProvider,
		private messageService: MessageService,
		private settingsService: SettingsProvider,
		private quoteUpdateService: QuoteUpdateService,
		private timeService: TimeServiceProvider,
		private invoiceDataService: InvoicesDataProvider
	) {}

	ngOnInit(): void {
		this.getTimeSettings();
	}

	dismiss(): void {
		this.disabledGalleryPresetSelect = false;
		this.name = this.jobName;
		this.submitDisable = false;
		this.galleryPresets = this.DEFAULT_GALLERY_PRESET;
		this.brandsGalleries = [];
		this.eventDate = this._mainShootDate;
		this.selectedBrandId = -1;
		this.selectedPresetId = -1;
		$('#createNewShootProofGalleryModal').modal('hide');
	}

	selectBrand(brandId): void {
		if (brandId != -1) {
			this.selectedBrandId = brandId;
			this.getPresets(brandId);
			this.getSelectedBrandThemeId();
		} else {
			this.selectedBrandId = -1;
			this.selectedPresetId = -1;
			this.galleryPresets = this.DEFAULT_GALLERY_PRESET;
		}
	}

	selectPreset(presetId): void {
		this.selectedPresetId = presetId;
	}

	getSelectedBrandThemeId(): void {
		this.brandsGalleries.forEach(item => {
			if (this.selectedBrandId == item.spBrandId) {
				this.spBrandThemeId = item.spHomeBrandThemeId;
			}
		});
	}

	getPresets(BrandId: number): void {
		this.disabledGalleryPresetSelect = true;
		this.galleryPresets = this.LOADING_GALLERY_PRESET;

		this.shootProofDataService
			.getGalleryPresetsV1(BrandId)
			.finally(() => (this.disabledGalleryPresetSelect = false))
			.subscribe(
				(data: any) => {
					this.galleryPresets = this.DEFAULT_GALLERY_PRESET.concat(data.data);
				},
				error => {
					this.galleryPresets = this.DEFAULT_GALLERY_PRESET;
					this.messageService.showDefaultErrorMessage(error);
				}
			);
	}

	private getTimeSettings(): void {
		this.settingsService.timeFormatSettings.subscribe((data): void => {
			switch (data.dateFormat) {
				case 'DD_MM_YYYY':
					this.datePlaceHolder = 'dd/mm/yyyy';
					break;
				case 'MM_DD_YYYY':
					this.datePlaceHolder = 'mm/dd/yyyy';
					break;
				default:
					this.datePlaceHolder = '';
					break;
			}
		});
	}

	private validationCreateNewGallery(): boolean {
		let validation = true;

		if (!this.name || this.name.trim() === '') {
			validation = false;
			this.messageService.showErrorFromBackend(
				'Oh Shoot!',
				'Please enter a name for your new gallery.'
			);
		} else if (this.selectedBrandId === -1) {
			validation = false;
			this.messageService.showErrorFromBackend(
				'Oh Shoot!',
				'Please select a brand for your new gallery.'
			);
		} else if (!this.eventDate || this.eventDate === null) {
			validation = false;
			this.messageService.showErrorFromBackend(
				'Oh Shoot!',
				'Please enter a shoot date for your new gallery.'
			);
		}

		return validation;
	}

	onSubmit(): void {
		if (!this.validationCreateNewGallery()) {
			return;
		}

		this.submitDisable = true;
		const settings = {
			jobId: this.jobId,
			spBrandId: +this.selectedBrandId,
			eventDate: this.timeService.getDateInFormat(
				this.eventDate.jsdate,
				'date'
			),
			name: this.name,
			galleryPresetId:
				this.selectedPresetId !== -1 ? +this.selectedPresetId : null,
			spBrandThemeId: this.spBrandThemeId
		};

		this.shootProofDataService
			.createShootProofNewGalleryFromSNV1(settings)
			.finally(() => (this.submitDisable = false))
			.subscribe(
				() => this.successCreateNewShootProofGallery(),
				error => {
					const { errorMessage, errorTitle } = error.error;
					this.messageService.showErrorFromBackend(errorTitle, errorMessage);
				}
			);
	}

	private successCreateNewShootProofGallery() {
		this.messageService.showToaster('s_1', 'shootProof');
		this.invoiceDataService.emitInvoiceUpdateEvent('UPDATE_SP_INVOICES');
		this.updateGalleries.emit();
		this.dismiss();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/integrations/shootProof/modals/create-new-shootProof-gallery-modal/create-new-shootProof-gallery.modal.ts